var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star_svg__a)",
    d: "M0 0h15.75v15H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "star_svg__c",
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star_svg__b)",
    d: "M0 0h15.75v15H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#star_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M0 0h15.75v15H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "star_svg__a",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star_svg__d",
    transform: "scale(.0119 .0125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "star_svg__b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star_svg__d",
    transform: "scale(.0119 .0125)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    id: "star_svg__d",
    width: 84,
    height: 80
  }))));
};
export default SvgStar;